import { Directive, inject } from '@angular/core'
import { ElderEnumTranslationService, ElderSelectComponent } from '@elderbyte/ngx-starter'
import { ShapePackagingStrategy } from './shape-packaging-strategy'

@Directive({
  selector: '[appShapePackagingStrategySelect]',
})
export class ShapePackagingStrategySelectDirective {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private select = inject(ElderSelectComponent)

  // TODO currently disabled, since not implemented!
  private readonly disabledStrategies = [
    ShapePackagingStrategy.BOX,
    ShapePackagingStrategy.RECTANGLE,
    ShapePackagingStrategy.VOLUME,
  ]

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const enumTranslationService = inject(ElderEnumTranslationService)
    this.select.placeholder = 'packaging.shape.strategy.title'
    this.select.displayProperty = 'displayValue'
    this.select.isOptionDisabledFn = (strategy) => this.isDisabled(strategy)
    this.select.dataSource = enumTranslationService.enumDataSource(
      ShapePackagingStrategy,
      'packaging.shape.strategy',
      false
    )
  }

  /***************************************************************************
   *                                                                         *
   * Private methods                                                         *
   *                                                                         *
   **************************************************************************/

  private isDisabled(strategy: any) {
    return this.disabledStrategies.some((dStrat) => dStrat === strategy?.value)
  }
}
